<template>
  <div class="graph as-flex main-center cross-center">
    <template v-if="has_result">
      <canvas class="graph-chart" ref="chart" id="myChart"></canvas>
    </template>
    <template v-else>
      <div class="graph-chart as-flex main-center cross-center f-3 fc-gray-2">影片类型感知可根据需求做定制挖掘，在此暂不呈现</div>
    </template>
  </div>
</template>

<script>
import colorManage from "../../utils/colorManage";

import debounceClass from "../../utils/functions";
const _debounce = new debounceClass().debounce;

import { clone } from "lodash";
export default {
  props: {
    config: {
      default: {
        movie_id: undefined,
        crowd: undefined,
        offset: undefined,
        is_div_me: true
      }
    }
  },
  data() {
    return {
      movieApi: this.$store.getters["movie/getMovieApi"],
      ctx: undefined,
      chart: undefined,
      graph_config: {},
      colorArr: clone(colorManage.movieColorArray),
      has_result: false
    };
  },
  computed: {
    queryParams: function() {
      let movie_id = Object.entries(this.config.movie_id).filter(item => {
        return item[0] !== "0";
      });
      if (movie_id.length > 0) {
        movie_id = movie_id[0][0];
      } else {
        movie_id = "";
      }
      return {
        movie_id: movie_id,
        crowd: Object.keys(this.config.crowd)[0],
        offset: this.config.offset.id,
        is_div_me: this.config.is_div_me
      };
    }
  },
  methods: {
    getIndicatorData: _debounce(async function(params) {
      if ([undefined, null, ""].includes(params.movie_id)) {
        //参数错误
        this.has_result = false;
        return;
      } else {
        this.has_result = true;
      }
      this.$emit("loadingStatus", true);
      let res = await this.movieApi.getIndicatorChartData(params);
      if (res.code !== 200 || res.status !== true) {
        this.$emit("loadingStatus", false);
        throw new Error("查询类型感知数据错误");
        return;
      }
      //抛出接口结果给上层，用以复制数据
      this.$emit("updateData", res.data);
      //----------------------------
      this.$emit("setOffset", res.data.offset);
      if (res.data.results.length === 0) {
        this.$emit("loadingStatus", false);
        this.has_result = false;
        return;
      }
      res.data.results = res.data.results.sort((a, b) => {
        return b.count - a.count;
      });

      let tempLabels = res.data.results.map(item => {
        return item.category;
      });
      let tempdata = res.data.results
        .map(item => {
          return ((item.count / item.base) * 100).toFixed(1);
        })
        .sort((a, b) => {
          return b - a;
        });
      if (tempdata.length > 10) {
        tempdata = tempdata.slice(0, 10);
        tempLabels = tempLabels.slice(0, 10);
      }
      let tempConfig = {
        labels: tempLabels,
        datasets: [
          {
            backgroundColor: this.colorArr || this.colorArr[3],
            borderColor: "rgba(0,0,0,0)",
            hoverBackgroundColor: this.colorArr || this.colorArr[3],
            // hoverBorderColor: this.colorArr || this.colorArr[3],
            borderWidth: 1,
            data: tempdata
          }
        ]
      };
      this.graph_config = Object.assign({}, tempConfig);
      if (this.chart) {
        this.chart.destroy();
      }
      this.createCharts(this.graph_config);
      this.$emit("loadingStatus", false);
    }, 500),
    createCharts(data) {
      if (this.chart) {
        this.chart.destroy();
      }
      this.ctx = this.$refs["chart"];
      this.chart = new Chart(this.ctx, {
        // The type of chart we want to create
        type: "horizontalBar",
        // The data for our dataset
        data: {
          labels: data.labels || [],
          datasets: data.datasets
        },
        // Configuration options go here
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 0,
              right: 40,
              top: 0,
              bottom: 0
            }
          },
          tooltips: {
            enabled: false,
            mode: "index",
            intersect: false,
            position: "nearest",
            xAlign: "center",
            yAlign: "center",
            titleFontSize: 8,
            bodyFontSize: 8,
            footerFontSize: 8,
            itemSort: (pre, cur) => {
              if (pre.yLabel >= cur.yLabel) {
                return -1;
              } else {
                return 1;
              }
            }
          },
          hover: {
            display: false
            // mode: "nearest",
            // intersect: true
          },
          legend: {
            display: false
          },
          scales: {
            yAxes: [
              {
                maxBarThickness: 10,
                display: true,
                scaleLabel: {
                  display: true
                },
                gridLines: {
                  color: "rgba(0, 0, 0, 0)", // 隐藏要y轴轴线
                  zeroLineColor: "#999999"
                },
                ticks: {
                  callback: function(value, index, values) {
                    if (value.length > 6) {
                      return value.slice(0, 6) + "..";
                    } else {
                      let diff = 6 - value.length;
                      for (let i = 0; i < diff; i++) {
                        value = `${value}`;
                      }
                      return value;
                    }
                  }
                }
                // afterFit: function(scaleInstance) {
                //   scaleInstance.width = 100; // sets the width to 100px
                //   // scaleInstance.width = 95;
                // }
              }
            ],
            xAxes: [
              {
                display: false,
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          },
          animation: {
            onComplete: function() {
              let ctx = this.chart.ctx;
              // ctx.canvas -= 40
              ctx.font = Chart.helpers.fontString(
                Chart.defaults.global.defaultFontFamily,
                "normal",
                Chart.defaults.global.defaultFontFamily
              );
              ctx.fillStyle = "#666666";
              ctx.textAlign = "center";
              ctx.textBaseline = "center";

              this.data.datasets.forEach(function(dataset) {
                dataset.data.forEach(function(bar, index) {
                  let model =
                    dataset._meta[Object.keys(dataset._meta)[0]].data[index]
                      ._model;
                  ctx.fillText(`${bar}%`, model.x + 20, model.y + 3);
                });
              });
            }
          }
        }
      });
    }
  },
  watch: {
    queryParams: {
      handler: async function(to, from) {
        await this.getIndicatorData(to);
      },
      deep: true
    }
  },
  async created() {
    await this.getIndicatorData(this.queryParams);
  },
  mounted() {
    // this.createCharts(this.graph_config);
  },
  destroyed() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};
</script>

<style lang="scss" scoped>
.graph-chart {
  width: 100%;
  height: 100%;
}
</style>


